// Public JavaScript bundle. Preserve dependency order; plugins require the jQuery global.
import "./src/cookies.js"
import "./lib/jquery.js"
import "./vendor/jquery_ujs.js"
import "./vendor/jquery.turbo.js"
import "jquery-ui-dist/jquery-ui.js"
import "./lib/load-image.js"
import "./vendor/canvas-to-blob.min.js"
// Provide the iframe transport fallback for file uploads.
import "./vendor/jquery.iframe-transport.js"
import "./vendor/jquery.fileupload.js"
import "./vendor/jquery.fileupload-process.js"
import "./vendor/jquery.fileupload-validate.js"
import "./vendor/jquery.fileupload-image.js"
import "./src/at_super_nested_form.js"
import "./vendor/signature_pad.min.js"
import "./lib/clipboard.js"
import "./lib/pusher.js"
import "./src/turbo_init.js"
import "./src/bootstrap/bs5.js"
// The vanilla Bootstrap 5 toggle plugin adds bootstrapToggle to checkbox elements.
// It requires window.bootstrap and initialises existing inputs on window load.
import "bootstrap5-toggle/js/bootstrap5-toggle.ecmas.js"
import "./lib/moment.js"
import "./vendor/bootstrap-datetimepicker.js"
import "./src/utilities/name_space_init.js"
import "./src/utilities/utilities.js.coffee"
import "./src/utilities/image_uploader.js.coffee"
import "./src/utilities/infinite_scroll.js.coffee"
import "./src/utilities/filterbar.js.coffee"
import "./src/utilities/course_video_player.js.coffee"
import "./src/utilities/entry_form_open_sections.js.coffee"
import "./src/bootstrap/bs5_controls.js.coffee"
import "./src/public/common.js.coffee"
import "./src/public/terms.js.coffee"
import "./src/public/login.js.coffee"
import "./src/public/declarations.js.coffee"
import "./src/public/briefing.js.coffee"
import "./src/public/users/users.js.coffee"
import "./src/public/owner_driver/owner_driver_series.js.coffee"
import "./src/public/owner_driver/owner_driver_event_entries.js.coffee"
import "./src/public/owner_driver/garage.js.coffee"
import "./src/public/owner_driver/garage_entries.js.coffee"
import "./src/public/owner_driver/orders.js.coffee"
import "./src/public/companies/companies.js.coffee"
import "./src/public/staff/entries.js.coffee"
import "./src/public/membership.js.coffee"
import "./lib/hogan.js"
import "./vendor/typeahead.js"
import "./src/public/organisations/entries.js.coffee"
import "./src/public/organisations/entrant_event_memberships.js.coffee"
